import { MenuIdPeople } from '@jira/navigation-apps__constants/src/MenuIdPeople.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { LazyTeamDashboardSidebar } from '@jira/navigation-apps__sidebar-eoc-team-dashboard/src/async.tsx';
import { opsTeamLayout } from '@jira/platform__layouts-ops-team-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { eocOnCallRedirectRoute } from '@jira/router-routes__eoc-on-call-routes/src/eocOnCallRedirectRoute.tsx';
import { resources as teamDashboardResources } from '@atlassian/eoc-team-dashboard/resources';
import type { Route, RouteResources } from '@atlassian/react-resource-router';
import { OnCallRedirect } from './ui/spa/eoc/on-call/index.tsx';

export const eocOnCallRedirectRouteEntry: Route = createEntry(eocOnCallRedirectRoute, () => ({
	group: 'eoc',
	// eslint-disable-next-line no-restricted-syntax
	component: OnCallRedirect,
	layout: opsTeamLayout,
	// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
	resources: [...getNavigationResources(), ...teamDashboardResources()] as RouteResources,

	navigation: {
		menuId: MenuIdPeople,
	},

	forPaint: [LazyAtlassianNavigation, LazyTeamDashboardSidebar],
	isRedirect: true,

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
